import axios from "axios";

import { BASE_URL } from "../../../constant";
import {
    handleFormatResponse,
    handleFormatResponseForError,
} from "../../../utility";

export const useAffiliateAccountsData = () => {
    const getAffiliateAccountsData = async (url: string) => {
        try {
            let response = await axios.get(`${BASE_URL}affiliate/accounts${url && url}`);
            const formattedResponse = handleFormatResponse(response);
            return formattedResponse;
        } catch (error: any) {
            const formattedError = handleFormatResponseForError(error);
            return formattedError;
        };
    };

    const postAffiliateAccountsData = async (url: string, payload: any) => {
        try {
            let response;
            if (payload == null) {
                response = await axios.post(`${BASE_URL}affiliate/accounts${url && url}`)
            } else {
                response = await axios.post(`${BASE_URL}affiliate/accounts${url}`, payload)
            };
            const formattedResponse = handleFormatResponse(response);
            return formattedResponse;
        } catch (error: any) {
            const formattedError = handleFormatResponseForError(error);
            return formattedError;
        };
    };

    const putAffiliateAccountsData = async (url: string, payload: any) => {
        try {
            let response = await axios.put(`${BASE_URL}affiliate/accounts${url && url}`, payload);
            const formattedResponse = handleFormatResponse(response);
            return formattedResponse;
        } catch (error: any) {
            const formattedError = handleFormatResponseForError(error);
            return formattedError;
        };
    };

    const patchAffiliateAccountsData = async (url: string, payload?: any) => {
        try {
            let response = await axios.patch(`${BASE_URL}affiliate/accounts${url && url}`, payload && payload);
            const formattedResponse = handleFormatResponse(response);
            return formattedResponse;
        } catch (error: any) {
            const formattedError = handleFormatResponseForError(error);
            return formattedError;
        };
    };

    const deleteAffiliateAccountsData = async (url: string) => {
        try {
            let response = await axios.delete(`${BASE_URL}affiliate/accounts${url && url}`);
            const formattedResponse = handleFormatResponse(response);
            return formattedResponse;
        } catch (error: any) {
            const formattedError = handleFormatResponseForError(error);
            return formattedError;
        };
    };


    return {
        getAffiliateAccountsData,
        postAffiliateAccountsData,
        putAffiliateAccountsData,
        patchAffiliateAccountsData,
        deleteAffiliateAccountsData
    };

};